import ModalSeePriceV1 from '@/modals/see-price/see-price-v1';
import ModalSeePriceV2 from '@/modals/see-price/see-price-v2';
import { useAppSelector } from '@/redux/store';
import { SliderSlice } from '@/redux/slider';
import { ConfigSlice } from '@/redux/config';
import Track from '@/utils/track';
import { goToOvm } from '@/utils/ovm-iusta';

const SeePriceMain = (props) => {
  const { onUpdateModifiers, modalHeight, scrollHeight, scrollTop } = props;

  const appendPoaToCTA = useAppSelector(ConfigSlice.selectors.appendPoaToCTA);
  const showPriceModal = useAppSelector(ConfigSlice.selectors.showPriceModal);
  const showPriceModalInsuranceCondition = useAppSelector(ConfigSlice.selectors.showPriceModalInsuranceCondition);
  const answersDirect = useAppSelector(SliderSlice.selectors.answersDirect);

  const update = ({ add, remove }) => {
    onUpdateModifiers && onUpdateModifiers({ add, remove });
  };

  const buttonClick = () => {
    Track.Experiments.SeePriceCtaButtonModal();
    void goToOvm(appendPoaToCTA, answersDirect);
  };

  const alternativeButtonClick = () => {
    Track.Experiments.SeePriceAlternativeCtaButtonModal();
    void goToOvm(appendPoaToCTA, answersDirect);
  };

  const moreClick = () => {
    Track.DataLayer.RueckversMoreInfoClick();
    Track.Experiments.RueckversMoreInfoClick();
  };

  const interestInDDVClick = () => {
    Track.DataLayer.InterestDdvClick();
    Track.Experiments.InterestDdvClick();
  };

  const initialStep = () => {
    if (answersDirect && answersDirect['legal_insurance']) {
      const valueFromCondition = showPriceModalInsuranceCondition[answersDirect['legal_insurance']];
      return valueFromCondition === 'insured' ? 1 : 2;
    } else {
      return 1;
    }
  };

  const isWithRSV = () => {
    if (answersDirect && answersDirect['legal_insurance']) {
      const valueFromCondition = showPriceModalInsuranceCondition[answersDirect['legal_insurance']];
      return valueFromCondition === 'insured' ? true : false;
    } else {
      return false;
    }
  };

  switch (showPriceModal) {
    case 1:
      return (
        <ModalSeePriceV1
          initialStep={initialStep()}
          onButtonClick={buttonClick}
          onMoreClick={moreClick}
          onUpdateModifiers={update}
          modalHeight={modalHeight}
          scrollHeight={scrollHeight}
          scrollTop={scrollTop}
        />
      );
    case 2:
      return (
        <ModalSeePriceV2
          withRSV={isWithRSV()}
          initialStep={1}
          onMoreClick={moreClick}
          onButtonClick={buttonClick}
          onAlternativeButtonClick={alternativeButtonClick}
          onUpdateModifiers={update}
          onInterestInDDV={interestInDDVClick}
        />
      );
    default:
      return null;
  }
};

export default SeePriceMain;
